import { OccupancyIndicator } from "@cmp-src/data-display/OccupancyIndicator/OccupancyIndicator";
import { Button } from "@cmp-src/primitives/button";
import {
  AgendaCardLayout,
  AgendaCardLayoutProps,
  pxRainbow
} from "./AgendaCardLayout";
import { AgendaCardButton } from "./AgendaCardLayout";
import { cn } from "@gettactic/helpers";
import { Loader } from "@mantine/core";

const buttonText = "Make reservation";

export const ReservationCard = ({
  isPastDate = false,
  isInOffice = true,
  onReservationClick,
  disabled = false,
  isLoadingDesksAvailability = false,
  availableDesks = 0,
  totalDesks = 0,
  layoutProps,
  officeName
}: {
  isPastDate?: boolean;
  isInOffice?: boolean;
  onReservationClick: () => void;
  disabled?: boolean;
  isLoadingDesksAvailability?: boolean;
  availableDesks?: number;
  totalDesks?: number;
  layoutProps?: AgendaCardLayoutProps;
  officeName?: string;
}) => {
  const checkIn = () => {
    onReservationClick();
  };
  if (!isInOffice) {
    return isPastDate ? (
      <div
        className={cn(
          "flex w-full items-center justify-center rounded-md border border-neutral-200 bg-neutral-100 p-3",
          pxRainbow
        )}
      >
        <p className="text-muted-foreground text-sm italic">
          No reservations for this date
        </p>
      </div>
    ) : (
      <Button
        onClick={checkIn}
        variant={"secondaryDashboard"}
        className={cn("w-full", pxRainbow)}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <AgendaCardLayout
      topLeft={
        <div className="flex items-center gap-1">
          {officeName && (
            <>
              <span className="font-medium font-inter">{officeName}</span>
              <span className="text-muted-foreground font-inter">-</span>
            </>
          )}
          <span className={"font-inter"}>No reservations</span>
        </div>
      }
      bottomLeft={
        <div
          className="flex flex-row gap-2 text-overlay text-xs"
          style={{ fontSize: 13 }}
        >
          {isLoadingDesksAvailability ? (
            <div className="flex items-center">
              <Loader color="var(--color-brand)" size="13" className="mr-2" />
              Checking desks availability...
            </div>
          ) : availableDesks > 0 ? (
            <>
              <OccupancyIndicator
                occupiedSpaces={availableDesks}
                totalSpaces={totalDesks}
                displaySpacesCount={false}
              />
              <div className={"font-semiBold font-inter text-neutral-600"}>
                {availableDesks}/{totalDesks} desks available
              </div>
            </>
          ) : (
            "No desks"
          )}
        </div>
      }
      button={
        isPastDate ? null : (
          <AgendaCardButton
            variant={"secondaryDashboard"}
            onClick={() => onReservationClick()}
          >
            {buttonText}
          </AgendaCardButton>
        )
      }
      {...layoutProps}
    />
  );
};
